import { render, staticRenderFns } from "./hotFocus.vue?vue&type=template&id=bcc92b9c&scoped=true&"
import script from "./hotFocus.vue?vue&type=script&lang=js&"
export * from "./hotFocus.vue?vue&type=script&lang=js&"
import style0 from "./hotFocus.vue?vue&type=style&index=0&id=bcc92b9c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc92b9c",
  null
  
)

export default component.exports